<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <!--<tr>
			<td>
				<img src="./../resource/mstar_dbrs_logo.png" width="350" height="100">
			</td>
		</tr>-->
          <tr>
            <td>
              <h4 style="margin-top: 10; margin-left: 50">
                Mumbai Task Level Feedback Form
              </h4>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!--<form id="form_id" ref="form" @submit.prevent="processForm" >-->
    <div class="container">
      <div class="row">
        <table class="table-horizontal" width="50%" height="20">
          <tbody>
            <tr>
              <td><strong>Date</strong></td>
              <td>
                <input
                  class="mumbai grayout"
                  type="date"
                  name="feeddate"
                  v-model="feeddate"
                  required
                  disabled
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Group Name</strong></td>
              <td v-if="groups.length === 1">
                <input
                  class="mumbai grayout"
                  readonly="true"
                  v-model="group"
                  @change="onGroupChange"
                />
              </td>
              <td v-else>
                <select
                  required
                  class="mumbai"
                  v-model="group"
                  id="grpname"
                  name="grpname"
                  @change="onGroupChange"
                >
                  <option
                    v-for="group in groups"
                    v-bind:key="group.id"
                    v-bind:id="group"
                  >
                    {{ group }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td><strong>Deal/Company Name</strong></td>
              <td>
                <input
                  class="mumbai"
                  type="text"
                  name="companyname"
                  size="29"
                  v-model="companyname"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Function Supported</strong></td>
              <td>
                <div id="functionsupporteddiv">
                  <select
                    required
                    class="mumbai"
                    v-model="functionSupported"
                    v-on:change="onFunctionChange"
                  >
                    <option
                      v-for="functionSupported in functionSupporteds"
                      v-bind:key="functionSupported.id"
                    >
                      {{ functionSupported }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>Tasks Performed</strong></td>
              <td v-if="group === 'CORPORATE'">
                <div
                  v-if="
                    functionSupported === 'Research' ||
                    functionSupported === 'Adhoc'
                  "
                  id="divTaskPerformed"
                >
                  <td>
                    <input
                      class="mumbai"
                      type="text"
                      name="taskperformed"
                      size="29"
                      v-model="task_performed"
                      required
                    />
                  </td>
                </div>
                <div v-else id="divTaskPerformed">
                  <select class="mumbai" v-model="task_performed" required>
                    <option
                      v-for="task_performed in task_performeds"
                      v-bind:key="task_performed.id"
                    >
                      {{ task_performed }}
                    </option>
                  </select>
                </div>
              </td>
              <td
                v-else-if="group === 'FIG' || group === 'SOVEREIGN AND PUB FIN'"
              >
                <div
                  v-if="functionSupported === 'Research'||
                    functionSupported === 'Adhoc'"
                  id="divTaskPerformed"
                >
                  <td>
                    <input
                      class="mumbai"
                      type="text"
                      name="taskperformed"
                      size="29"
                      v-model="task_performed"
                      required
                    />
                  </td>
                </div>
                <div v-else id="divTaskPerformed">
                  <select class="mumbai" v-model="task_performed" required>
                    <option
                      v-for="task_performed in task_performeds"
                      v-bind:key="task_performed.id"
                    >
                      {{ task_performed }}
                    </option>
                  </select>
                </div>
              </td>
              <td
                v-else-if="
                  group === 'EU CORP' || group === 'DIVERSIFIED INDUSTRIES'
                "
              >
                <div
                  v-if="
                    functionSupported === 'Research' ||
                    functionSupported === 'Adhoc'
                  "
                  id="divTaskPerformed"
                >
                  <td>
                    <input
                      class="mumbai"
                      type="text"
                      name="taskperformed"
                      size="29"
                      v-model="task_performed"
                      required
                    />
                  </td>
                </div>
                <div v-else id="divTaskPerformed">
                  <select class="mumbai" v-model="task_performed" required>
                    <option
                      v-for="task_performed in task_performeds"
                      v-bind:key="task_performed.id"
                    >
                      {{ task_performed }}
                    </option>
                  </select>
                </div>
              </td>

              <td v-else>
                <div id="divTaskPerformed">
                  <select required class="mumbai" v-model="task_performed">
                    <option
                      v-for="task_performed in task_performeds"
                      v-bind:key="task_performed.id"
                    >
                      {{ task_performed }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>Primary Analyst Email ID</strong></td>
              <td>
                <combobox
                  :emails="emails"
                  v-model="usanalystid"
                  class="mumbai"
                  required
                ></combobox>
              </td>
            </tr>
            <tr>
              <td><strong>Mumbai Analyst Email ID</strong></td>
              <td>
                <input
                  class="mumbai"
                  type="email"
                  name="mumbaianalystid"
                  v-model="mumbaianalystid"
                  size="29"
                  required
                  disabled
                />
              </td>
            </tr>
            <tr v-if="message && task_performed === 'Par Report'">
              <td><strong>Par Due Date</strong></td>
              <td>
                <input
                  class="mumbai"
                  name="par_due_date"
                  type="date"
                  id="userdate"
                  v-model="par_due_date"
                  required
                  style="width: 273px"
                />
              </td>
              <!-- <td ><input class="mumbai" type="date" name="feeddate" v-model="feeddate" required
							style="width: 273px"></td> -->
            </tr>
            <tr id="Comment">
              <td><strong>Comment</strong></td>
              <td>
                <textarea
                  style="width: 273px; margin-top: 10px"
                  v-model="comment"
                  name="comment"
                ></textarea>
                <div id="commentdiv">
                  <span v-on:click="expandComment" style="color: blue"
                    ><u>click here to expand comment box</u></span
                  >
                  <div id="tooltip1" class="tooltip1">
                    <textarea
                      style="width: 100%; height: 100%"
                      v-model="comment"
                    >
                    </textarea>
                    <button type="button" v-on:click="closeComment">
                      Close
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <br />
            <tr id="Attach">
              <td><strong>Attach file</strong></td>
              <td>
                <input
                  type="file"
                  id="files"
                  ref="files"
                  multiple
                  v-on:change="handleFilesUpload"
                />
                <div class="large-12 medium-12 small-12 cell">
                  <div
                    v-for="(file, key) in files"
                    class="file-listing"
                    v-bind:key="key.id"
                    v-bind:id="key"
                  >
                    {{ file.name }}
                    <span class="remove-file" v-on:click="removeFile(key)"
                      >Remove</span
                    >
                  </div>
                </div>
                <!-- <br> -->
                <div class="large-12 medium-12 small-12 cell">
                  <button v-on:click="addFiles()">Add Files</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <button
          style="margin-top: 20px"
          type="submit"
          :disabled="isnotActive"
          v-on:click="submitForm"
        >
          Submit
        </button>
      </div>
    </div>
    <div id="submit-loader" style="display: none">
      <clip-loader :color="'#56A5EC'" :size="size"></clip-loader>
    </div>
    <!-- </form> -->
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import moment from "moment";
import { axiosInit } from "../axios-interceptor";
import combobox from "@/reusableComponents/comboBox";
import ClipLoader from "../../node_modules/vue-spinner/src/ClipLoader.vue";

const S3_DIRECTORY = "mumbai-feedback-files/";
export default {
  name: "HelloWorld",
  props: { msg: String },
  components: { combobox, ClipLoader },
  data() {
    return {
      isnotActive: false,
      message: false,
      //file:'',
      files: [],
      attach: [],
      s3PresignedURLAndFileName: {},
      feeddate: "",
      companyname: "",
      functionSupported: "",
      group: "",
      task_performed: "",
      usanalystid: "",
      mumbaianalystid: "",
      par_due_date: "",
      comment: "",
      groups: [],
      function_emea: ["New Issuance", "Surveillance", "Research"],
      STRUCTURED_CREDIT_Surveillance: [
        "Model",
        "Memo or Presale or Publication",
        "Entire Deal",
      ],
      functionSupporteds: [],
      function_json: {
        RMBS: ["New Issuance", "Surveillance"],
        CMBS: ["New Issuance", "Surveillance", "Research"],
        FIG: ["New Issuance", "Surveillance", "Research", "Adhoc"],
        STRUCTURED_CREDIT: ["New Issuance", "Surveillance", "Research"],
        CORPORATE: ["New Issuance", "Surveillance", "Research", "Adhoc"],
        ABS: ["New Issuance", "Surveillance"],
        Credit_Estimate: ["New Issuance", "Surveillance"],
        CASHFLOW: ["New Issuance", "Surveillance"],
        CANADIAN_SF: ["Surveillance"],
        EU_Corp: ["New Issuance", "Surveillance", "Research", "Adhoc"],
        Diversified_Industries: [
          "New Issuance",
          "Surveillance",
          "Research",
          "Adhoc",
        ],
        Sovereign_and_Pub_Fin: [
          "New Issuance",
          "Surveillance",
          "Research",
          "Adhoc",
        ],
        FUNDS: ["New Issuance", "Surveillance"],
      },
      task_performeds: [],
      task_json: {
        FIG: {
          "New Issuance": [
            "IAX",
            "RC Package prep",
            "Financial Tool Updates (Historical)",
          ],
          Surveillance: ["IAX", "RC Package prep", "Financial Tool Updates"],
          Research: [""],
          Adhoc: ["IAX"],
        },
        RMBS: { "New Issuance": ["Non-SFR", "SFR"], Surveillance: ["SFR"] },
        EMEA: {
          "New Issuance": ["Par Report"],
          Surveillance: ["Par Report", "Memo/Press Release"],
          Research: ["Par Report"],
        },
        CMBS: {
          "New Issuance": ["NCF Analysis", "NCF Set-ups", "Presale", 
          "Working Tape & Model Run"
        ],
          Surveillance: [
            "Deal Surveillance",
            "CRE CLO RAC requests",
            "NCF Analysis",
            "BP Updates Write-up",
            "Deal Support_SA",
            "Deal Support_DA",
          ],
          Research: [
            "Deal Surveillance",
            "CRE CLO RAC requests",
            "BP Updates Write-up",
          ],
        },
        STRUCTURED_CREDIT: {
          "New Issuance": [
            "Model",
            "Memo or Presale or Publication",
            "Entire Deal",
          ],
          Surveillance: [
            "Model_Surveillance",
            "Memo or Presale or Publication",
            "Entire Deal_Surveillance",
          ],
          Research: ["Research Support"],
        },
        CORPORATE: {
          "New Issuance": [
            "Data Mining",
            "Data mining and Forecasting",
            "Contribution to RC Memo",
          ],
          Surveillance: [
            "Data Mining",
            "Data mining and Forecasting",
            "Contribution to RC Memo",
          ],
          Research: [""],
          Adhoc: [""],
        },
        ABS: {
          "New Issuance": [
            "Entire Deal",
            "Preparation of Model Input Data",
            "Memo/Presale/Publication",
            "Administrative Tasks",
			"Sector Review"
          ],
          Surveillance: [
            "Hydra Mapping / PAR Creation",
            "PAR QC",
            "Discussion Group",
            "SRC",
            "Model",
            "Administrative Tasks",
            "Publication",
          ],
        },
        Credit_Estimate: {
          "New Issuance": ["Credit Estimate Cases"],
          Surveillance: ["Credit Estimate Cases"],
        },
        CASHFLOW: {
          "New Issuance": ["Cashflow Analytics"],
          Surveillance: ["Cashflow Analytics"],
        },
        CANADIAN_SF: {
          Surveillance: [
            "Data Extraction",
            "New Deal Template Setup",
            "Surveillance Report",
          ],
        },
        EU_Corp: {
          "New Issuance": [
            "Financial Tool Updates (Historical)",
            "Financial Tool Updates",
            "IAX",
            "Contribution to RC Memo (Basic)",
            "Contribution to RC Memo (Comprehensive)",
          ],
          Surveillance: [
            "Financial Tool Updates (Historical)",
            "Financial Tool Updates",
            "IAX",
            "Contribution to RC Memo (Basic)",
            "Contribution to RC Memo (Comprehensive)",
          ],
          Research: [""],
          Adhoc: [""],
        },
        Diversified_Industries: {
          "New Issuance": [
            "Financial Tool Updates (Historical)",
            "Financial Tool Updates",
            "IAX",
            "Contribution to RC Memo (Basic)",
            "Contribution to RC Memo (Comprehensive)",
          ],
          Surveillance: [
            "Financial Tool Updates (Historical)",
            "Financial Tool Updates",
            "IAX",
            "Contribution to RC Memo (Basic)",
            "Contribution to RC Memo (Comprehensive)",
          ],
          Research: [""],
          Adhoc: [""],
        },
        Sovereign_and_Pub_Fin: {
          "New Issuance": [
            "Financial Tool Updates (Historical)",
            "Financial Tool Updates",
            "IAX",
            "Contribution to RC Memo (Basic)",
            "Contribution to RC Memo (Comprehensive)",
          ],
          Surveillance: [
            "Financial Tool Updates (Historical)",
            "Financial Tool Updates",
            "IAX",
            "Contribution to RC Memo (Basic)",
            "Contribution to RC Memo (Comprehensive)",
          ],
          Research: [""],
          Adhoc: [""],
        },
        FUNDS: {
          "New Issuance": ["Modelling Support",
            "Memos & Disclosures","Entire Deal_New Issue"
          ],
          Surveillance: ["Modelling Support", "Memos & Disclosures","Entire Deal_Surveillance"],
        },
      },
      objVal: {},
      emails: [],
      usAnalystFlag: false,
    };
  },

  async beforeCreate() {
    const getUrl = new URL(process.env.VUE_APP_BACKEND_API + "getEmails");
    this.groups = store.methods.getGroup();

    getUrl.searchParams.append("group", this.groups);

    const response = await axios
      .get(getUrl)
      .then((response) => (this.jsonresponse = response))
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
    this.jsonresponse = response.data;
    this.emails = this.jsonresponse.map((data) => {
      return data["email"];
    });
  },
  created() {
    this.feeddate = moment().format("YYYY-MM-DD");

    this.groups = store.methods.getGroup();
    if (this.groups.length === 1) {
      this.group = this.groups[0];
    }
    this.mumbaianalystid = store.methods.getUser();
    if (this.groups.length === 1) {
      this.group = this.groups[0];

      if (this.group === "EMEA RMBS/ABS") {
        this.functionSupporteds = Object.keys(this.task_json.EMEA);
        this.message = true;
      } else if (this.group === "STRUCTURED CREDIT") {
        this.functionSupporteds = Object.keys(this.task_json.STRUCTURED_CREDIT);
        this.message = false;
      } else if (
        this.group === "CREDIT ESTIMATE" ||
        this.group === "Credit Estimate"
      ) {
        this.functionSupporteds = Object.keys(this.task_json.Credit_Estimate);
        this.message = false;
      } else if (this.group === "CANADIAN SF") {
        this.functionSupporteds = Object.keys(this.task_json.CANADIAN_SF);
        this.message = false;
      } else if (this.group === "EU CORP") {
        this.functionSupporteds = Object.keys(this.task_json.EU_Corp);
        this.message = false;
      } else if (this.group === "DIVERSIFIED INDUSTRIES") {
        this.functionSupporteds = Object.keys(
          this.task_json.Diversified_Industries,
        );
        this.message = false;
      } else if (this.group === "SOVEREIGN AND PUB FIN") {
        this.functionSupporteds = Object.keys(
          this.task_json.Sovereign_and_Pub_Fin,
        );
        this.message = false;
      } 
        else if (this.group === "FUNDS") {
        this.functionSupporteds = Object.keys(
          this.task_json.FUNDS,
        );
        this.message = false;
      } 
        else {
        this.functionSupporteds = Object.keys(this.task_json[this.group]);
        this.message = false;
      }
    }
  },
  methods: {
    resetForm() {
      this.isnotActive = false;
      this.feeddate = moment().format("YYYY-MM-DD");
      this.companyname = "";
      this.functionSupported = "";
      this.task_performed = "";
      this.usanalystid = "";
      this.par_due_date = "";
      this.comment = "";
      this.files = [];
      this.message = false;
      this.mumbaianalystid = store.methods.getUser();

      if (this.groups.length === 1) {
        this.group = this.groups[0];
        this.onGroupChange();
      } else {
        this.group = "";
        this.functionSupporteds = [];
        this.task_performeds = [];
      }
    },
    buildS3FileName(fileName) {
      const safeName = String(fileName || "attachment");
      const ext = (safeName.match(/\.[^./]+$/) || [""])[0];
      const base =
        safeName.slice(0, safeName.length - ext.length) || "attachment";
      return `${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 10)}__${encodeURIComponent(base)}${ext}`;
    },
    dateDisable() {
      document.getElementById("feedDate").disabled = true;
    },
    addFiles() {
      this.$refs.files.click();
    },
    checkFeedDate() {
      if (new Date(this.feeddate).getTime() >= new Date().getTime()) {
        alert("The Date must be Smaller or Equal to today date");
        this.feeddate = "";
      }
    },
    handleFilesUpload() {
      //this.file = this.$refs.file.files[0];
      let uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        let fileObj = {};
        fileObj.name = uploadedFiles[i].name;
        fileObj.s3Name = this.buildS3FileName(uploadedFiles[i].name);
        fileObj.fileinstance = uploadedFiles[i];
        this.files.push(fileObj);
      }
      this.$refs.files.value = "";
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    async getPresignedURL(fileName, contentType) {
      const url =
        process.env.VUE_APP_RCA_LAMBDA +
        "presigned_url?" +
        new URLSearchParams({
          fileName: S3_DIRECTORY + fileName,
          fileType: contentType || "application/octet-stream",
        });
      const s3PresignedURL = fetch(url, {
        method: "get",
        credentials: "include",
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("failed to get Presigned URL");
          }
        })
        .catch((err) => console.error(`${err.message}`));
      return s3PresignedURL;
    },
    upload(s3UploadURL = "", file, file_type) {
      // using fetch here because AWS requires to set correct content-type
      const resolvedType = file_type || "application/octet-stream";
      const res = fetch(s3UploadURL, {
        method: "PUT",
        headers: { "Content-Type": resolvedType },
        body: file,
      })
        .then((res) => {
          if (res.ok) {
            //console.log(`files uploaded to S3 sucessfully`)
            return res;
          } else {
            throw new Error("failed to upload file to S3 bucket");
          }
        })
        .catch((err) => {
          console.error(`${err.message}`);
          alert(err.message);
          throw new Error(err.message);
        });
      return res;
    },
    async UploadfilesToS3(files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        const respdata = await this.getPresignedURL(
          file.s3Name,
          file.fileinstance.type,
        );
        const newFile_name = file.name;
        const newFile = new File([file.fileinstance], newFile_name, {
          type: file.fileinstance.type,
        });
        await this.upload(respdata, newFile, newFile.type);
      }
      return this.files;
    },
    async submitForm() {
      console.log("submmit invoked");
      axiosInit();
      this.usAnalystFlag = this.emails.includes(this.usanalystid.toLowerCase());

      if (
        /@morningstar.com$/.test(this.mumbaianalystid) &&
        /@morningstar.com$/.test(this.usanalystid) &&
        this.usAnalystFlag &&
        this.mumbaianalystid != this.usanalystid
      ) {
        let fileNames = [];
        this.isnotActive = true;
        if (this.files && this.files && this.files.length > 0) {
          console.log("init file upload");
          // upload files to s3
          await this.UploadfilesToS3(this.files);
        }

        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          fileNames.push(file.s3Name);
        }

        const formData = {
          feeddate: this.feeddate,
          grpname: this.group,
          companyname: this.companyname,
          functionsupported: this.functionSupported,
          tasksperformed: this.task_performed,
          usanalystid: this.usanalystid,
          mumbaianalystid: this.mumbaianalystid,
          Par_due_date: this.par_due_date,
          comment: this.comment,
          files: fileNames,
        };
        document.getElementById("submit-loader").style.display = "block";
        axios
          .post(process.env.VUE_APP_BACKEND_API + "mumbaifeedback", formData, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          })
          .then(() => {
            var x = document.cookie;
            console.log(JSON.stringify(x));
            document.getElementById("submit-loader").style.display = "none";
            alert("Feedback Request Submitted");
            this.resetForm();
            console.log("SUCCESS!!");
          });
      } else {
        this.isnotActive = false;

        if (!this.usAnalystFlag) {
          alert("Enter correct Us Analyst email id");
          this.usanalystid = "";
        }
        if (this.usanalystid == this.mumbaianalystid) {
          alert(
            "Mumbai Analyst field and Primary Analyst field cannot be the same. ",
          );
          this.usanalystid = "";
          this.mumbaianalystid = store.methods.getUser();
        }
        if (
          !/@morningstar.com$/.test(this.mumbaianalystid) &&
          this.mumbaianalystid.length > 0
        ) {
          alert("Enter correct email id");
        }

        if (
          !/@morningstar.com$/.test(this.usanalystid) &&
          this.usanalystid.length > 0
        ) {
          alert("Enter correct email id");
        }
      }
    },
    onGroupChange() {
      if (this.group === "EMEA RMBS/ABS") {
        this.functionSupporteds = Object.keys(this.task_json.EMEA);
        this.message = true;
      } else if (this.group === "STRUCTURED CREDIT") {
        this.functionSupporteds = Object.keys(this.task_json.STRUCTURED_CREDIT);
        this.message = false;
      } else if (
        this.group === "CREDIT ESTIMATE" ||
        this.group === "Credit Estimate"
      ) {
        this.functionSupporteds = Object.keys(this.task_json.Credit_Estimate);
        this.message = false;
      } else if (this.group === "CANADIAN SF") {
        this.functionSupporteds = Object.keys(this.task_json.CANADIAN_SF);
        this.message = false;
      } else if (this.group === "EU CORP") {
        this.functionSupporteds = Object.keys(this.task_json.EU_Corp);
        this.message = false;
      } else if (this.group === "DIVERSIFIED INDUSTRIES") {
        this.functionSupporteds = Object.keys(
          this.task_json.Diversified_Industries,
        );
        this.message = false;
      } else if (this.group === "SOVEREIGN AND PUB FIN") {
        this.functionSupporteds = Object.keys(
          this.task_json.Sovereign_and_Pub_Fin,
        );
        this.message = false;
      } 
        else if (this.group === "FUNDS") {
        this.functionSupporteds = Object.keys(
          this.task_json.FUNDS,
        );
        this.message = false;
      } 
        else {
        this.functionSupporteds = Object.keys(this.task_json[this.group]);
        this.message = false;
      }
      this.onFunctionChange();
    },

    onFunctionChange() {
      if (this.group === "EMEA RMBS/ABS") {
        this.task_performeds = this.task_json["EMEA"][this.functionSupported];
      } else if (this.group === "STRUCTURED CREDIT") {
        this.task_performeds =
          this.task_json["STRUCTURED_CREDIT"][this.functionSupported];
      } else if (
        this.group === "CREDIT ESTIMATE" ||
        this.group === "Credit Estimate"
      ) {
        this.task_performeds =
          this.task_json["Credit_Estimate"][this.functionSupported];
      } else if (this.group === "CORPORATE") {
        if (
          this.functionSupported !== "Research" ||
          this.functionSupported !== "Research"
        ) {
          this.task_performeds =
            this.task_json[this.group][this.functionSupported];
        }
      } else if (this.group === "CANADIAN SF") {
        this.task_performeds =
          this.task_json["CANADIAN_SF"][this.functionSupported];
      } else if (this.group === "EU CORP") {
        this.task_performeds =
          this.task_json["EU_Corp"][this.functionSupported];
      } else if (this.group === "DIVERSIFIED INDUSTRIES") {
        this.task_performeds =
          this.task_json["Diversified_Industries"][this.functionSupported];
      } else if (this.group === "SOVEREIGN AND PUB FIN") {
        this.task_performeds =
          this.task_json["Sovereign_and_Pub_Fin"][this.functionSupported];
      } 
        else if (this.group === "FUNDS") {
        this.task_performeds =
          this.task_json["FUNDS"][this.functionSupported];
      } 
        else {
        this.task_performeds =
          this.task_json[this.group][this.functionSupported];
      }
      if (this.task_performed) {
        this.task_performed = "";
      }
    },
    expandComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "visible";
      document.getElementById("tooltip1").style.opacity = "1";
    },
    closeComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "hidden";
      document.getElementById("tooltip1").style.opacity = "0";
    },
    getFormattedDate(date) {
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");

      return month + "/" + day + "/" + year;
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}

.select-editable {
  position: relative !important;
  background-color: white !important;
  border: solid grey 1px !important;
  width: 273px !important;
  height: 18px !important;
}

.select-editable select {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  border: none !important;
  width: 273px !important;
  margin: 0 !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.select-editable input {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100px !important;
  padding: 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: none !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
}

.select-editable select:focus,
.select-editable input:focus {
  outline: none !important;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 60%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#mumbai_div {
  margin-left: 20px;
}

#mumbai_title {
  text-align: left;
}
.mumbai {
  width: 273px;
  margin-top: 10px;
  height: 25px;
}

input[type="file"] {
  position: absolute;
  top: -500px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}
.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}
.o-combobox[data-v-3ce6f2fc] {
  max-width: 274px !important;
}
</style>
